import { combineReducers } from "redux";
import mainReducer from "@gc-npm/reducers.main-reducer";
import modalsReducer from "@gc-npm/reducers.modals-reducer";
import headerReducer from "@gc-npm/reducers.header-reducer";
import retargetingReducer from "./retargeting";
import tradeInReducer from "./devices";

const REDUCERS_LIST = {
  main: mainReducer,
  modals: modalsReducer,
  header: headerReducer,
  retargeting: retargetingReducer,
  tradeIn: tradeInReducer,
};

const rootReducers = () =>
  combineReducers({
    ...REDUCERS_LIST,
  });

export default rootReducers;
